module.exports = __webpack_public_path__ + "media/images/emp/model_overview-23f85846fe922d2dabb0c83af9f08800.png";